import { FC } from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

interface Props {
  isAppPopup?: boolean;
}

const INGREDIENT_INFO = [
  {
    subject: '',
    text: '제공되는 정보는 구매를 돕기 위한 부가적인 정보로 참고 자료로만 활용하시길 권장 드리며 구매 전 화장품 제조업자 및 판매업자의 상세정보를 확인하시길 바랍니다.',
  },
  {
    subject: '목적별 성분',
    text: '성분 정보는 판매업자가 작성한 전 성분 표기에 기초하여 작성되었으며, 판매업자가 표준화된 성분명으로 기재하지 않은 등 특이사항이 있는 경우 일부 성분에 대한 정보가 제공되지 않습니다. 식품의약품안전처고시 규정에 따른 알레르기 유발성분, 기능성 화장품 정보와 개별 성분의 주된 배합 목적을 매칭하여 제공하고 있으며 성분간의 배합, 개인의 피부와 사용 환경 등에 따라 제품의 효능, 효과는 변경될 수 있습니다.',
  },
  {
    subject: '한줄평 리뷰',
    text: '지그재그를 통해 상품을 구매한 유저 중 맞춤 정보를 작성한 유저의 데이터와 작성된 리뷰를 바탕으로 정보를 제공하고 있습니다. 개인의 맞춤 정보와 리뷰 평가는 개개인에 따라 주관적으로 평가될 수 있으므로 상품 추가 정보를 확인하기 위한 용도로만 사용하시길 바랍니다.',
  },
];

export const IngredientInfoView: FC<React.PropsWithChildren<Props>> = ({ isAppPopup = false }) => {
  return (
    <Root isAppPopup={isAppPopup}>
      <Title className={Typography.HEAD_20_BOLD}>상품 요약 안내</Title>
      <Contents>
        {INGREDIENT_INFO.map(({ subject, text }, idx) => (
          <Item key={idx}>
            {subject && <Subject className={Typography.BODY_15_SEMIBOLD}>{subject}</Subject>}
            {text && <InfoText className={Typography.BODY_14_REGULAR}>{text}</InfoText>}
          </Item>
        ))}
      </Contents>
    </Root>
  );
};

const Root = styled.section<{ isAppPopup?: boolean }>`
  padding-top: 2px;
  ${({ isAppPopup }) => !isAppPopup && 'margin: 40px 16px 30px;'}
`;

const Title = styled.p`
  display: flex;
  align-items: center;
`;

const Contents = styled.div`
  padding: 10px 0 16px;
`;

const Item = styled.article`
  margin-bottom: 24px;
`;

const Subject = styled.p`
  margin-bottom: 8px;
  color: ${vars.v3Color.gray900};
`;

const InfoText = styled.p`
  line-height: 140%;
  color: ${vars.v3Color.gray600};
`;
